import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { HomeIcon, UsersIcon, BookOpenIcon, CheckSquareIcon, UserIcon, BellIcon, ChevronRightIcon, AlertCircleIcon, CheckCircle2Icon, ClockIcon, XIcon, ShieldAlertIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
// --- Mock Data ---
const FAMILY_MEMBERS = [{
  id: '1',
  name: 'Jason Phillips',
  initials: 'JP',
  role: 'Super Guardian',
  score: 612,
  status: 'On Track',
  statusColor: 'text-[#0EB4CC] bg-[#0EB4CC]/10',
  avatarColor: 'bg-[#1a0647]'
}, {
  id: '2',
  name: 'Lois Brady',
  initials: 'LB',
  role: 'Adult Member',
  score: 412,
  status: 'Needs Attention',
  statusColor: 'text-amber-600 bg-amber-50',
  avatarColor: 'bg-[#8528e2]'
}, {
  id: '3',
  name: 'Dan Phillips',
  initials: 'DP',
  role: 'Adult Member',
  score: 380,
  status: 'Needs Attention',
  statusColor: 'text-amber-600 bg-amber-50',
  avatarColor: 'bg-[#0EB4CC]'
}, {
  id: '4',
  name: 'Leslie Phillips',
  initials: 'LP',
  role: 'Guardian',
  score: 650,
  status: 'On Track',
  statusColor: 'text-[#0EB4CC] bg-[#0EB4CC]/10',
  avatarColor: 'bg-[#631bb7]'
}];
const ACTIVITY_FEED = [{
  id: 1,
  icon: <CheckCircle2Icon className="text-green-500" size={20} data-id="element-2020" data-mp="2zfri4pem1mrt" />,
  title: 'Mom completed Password Manager setup',
  time: '2 hours ago',
  member: 'Lois Brady'
}, {
  id: 2,
  icon: <AlertCircleIcon className="text-amber-500" size={20} data-id="element-2021" data-mp="3r54hu8ab9whj" />,
  title: "Dad's phone is running outdated software",
  time: '5 hours ago',
  member: 'Dan Phillips'
}, {
  id: 3,
  icon: <UsersIcon className="text-[#8528e2]" size={20} data-id="element-2022" data-mp="3i4g1h6xg3k1h" />,
  title: 'Leslie joined the family plan',
  time: '1 day ago',
  member: 'Leslie Phillips'
}];
export function GuardianDashboardPage() {
  const [activeTab, setActiveTab] = useState('Home');
  const [selectedMember, setSelectedMember] = useState<any | null>(null);
  const [drawerTab, setDrawerTab] = useState('Overview');
  return <div className="min-h-screen bg-[#f8f8f8] flex flex-col md:flex-row font-sans" data-id="element-2023" data-mp="1inxkalxh5imm">
      {/* --- Desktop Sidebar --- */}
      <aside className="hidden md:flex flex-col w-64 bg-[#1a0647] text-white fixed h-full z-20" data-id="element-2024" data-mp="1dubf1etn4h0u">
        <div className="p-6" data-id="element-2025" data-mp="18wt27dci5hnk">
          <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-6" data-id="element-2026" data-mp="13xykyfu6o15k" />
        </div>
        <nav className="flex-1 px-4 space-y-2 mt-4" data-id="element-2027" data-mp="uws1bxw8ma83">
          {[{
          name: 'Home',
          icon: HomeIcon
        }, {
          name: 'Family',
          icon: UsersIcon
        }, {
          name: 'Actions',
          icon: BookOpenIcon
        }, {
          name: 'Tasks',
          icon: CheckSquareIcon
        }, {
          name: 'Profile',
          icon: UserIcon
        }].map(item => <button key={item.name} onClick={() => setActiveTab(item.name)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${activeTab === item.name ? 'bg-[#8528e2] text-white font-semibold' : 'text-gray-300 hover:bg-white/10'}`} data-id="element-2028" data-mp="2wszm6e26jbm2">
              <item.icon size={20} data-id="element-2029" data-mp="28z7uhn2bfhnq" />
              {item.name}
            </button>)}
        </nav>
      </aside>

      {/* --- Main Content --- */}
      <main className="flex-1 md:ml-64 pb-24 md:pb-8" data-id="element-2030" data-mp="2iu9ooxbg79x6">
        {/* Top Bar */}
        <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 z-10" data-id="element-2031" data-mp="2mwwg4x47istu">
          <h1 className="text-xl md:text-2xl font-bold text-[#1a0647]" data-id="element-2032" data-mp="3u9ohdowmjfmh">
            Good morning, Jason
          </h1>
          <div className="flex items-center gap-4" data-id="element-2033" data-mp="28i70pgieouw">
            <button className="relative p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2034" data-mp="ogo75i879fv">
              <BellIcon size={24} data-id="element-2035" data-mp="3rwurql5krvst" />
              <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-2036" data-mp="3rxnsn5hurr31"></span>
            </button>
            <div className="w-10 h-10 rounded-full bg-[#1a0647] text-white flex items-center justify-center font-bold" data-id="element-2037" data-mp="5o39m287jvzr">
              JP
            </div>
          </div>
        </header>

        <div className="p-6 max-w-5xl mx-auto space-y-8" data-id="element-2038" data-mp="epknddy57lla">
          {/* Stat Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2039" data-mp="tdxik8pep0eq">
            {/* Score Card */}
            <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center gap-5" data-id="element-2040" data-mp="oeuil2oa9kdm">
              <div className="relative w-16 h-16 shrink-0" data-id="element-2041" data-mp="12e3uvr9dbucb">
                <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100" data-id="element-2042" data-mp="12cj2a76m6lh3">
                  <circle cx="50" cy="50" r="45" fill="none" stroke="#f3f4f6" strokeWidth="10" data-id="element-2043" data-mp="1h12krhskugox" />
                  <circle cx="50" cy="50" r="45" fill="none" stroke="#0EB4CC" strokeWidth="10" strokeLinecap="round" strokeDasharray="282.7" strokeDashoffset={282.7 - 282.7 * 0.612} data-id="element-2044" data-mp="1804c2m771l00" />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-2045" data-mp="pbzg40ws34br">
                  <span className="text-sm font-bold text-[#111111]" data-id="element-2046" data-mp="tcjd94hcq7xw">612</span>
                </div>
              </div>
              <div data-id="element-2047" data-mp="fcqnbbdnfvqz">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2048" data-mp="febb8i5gkgfv">
                  Family Score
                </p>
                <p className="text-sm text-gray-600" data-id="element-2049" data-mp="2m195cmmy64tt">
                  <span className="text-[#0EB4CC] font-bold" data-id="element-2050" data-mp="2h9irw7spr0y6">On Track</span> to
                  reach 1000
                </p>
              </div>
            </div>

            {/* Modules Card */}
            <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex flex-col justify-center" data-id="element-2051" data-mp="2d5jh85u46wcq">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-2052" data-mp="34ytk30vzzn0p">
                Actions Completed
              </p>
              <div className="flex items-end gap-2 mb-2" data-id="element-2053" data-mp="30xzxcauake9e">
                <span className="text-2xl font-bold text-[#111111] leading-none" data-id="element-2054" data-mp="2vxvptabd2tvb">
                  14
                </span>
                <span className="text-sm text-gray-500 font-medium mb-0.5" data-id="element-2055" data-mp="2qy94edldq7bf">
                  / 37
                </span>
              </div>
              <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-2056" data-mp="1kgvnrmz7p0o3">
                <div className="h-full bg-[#8528e2] w-[37%] rounded-full" data-id="element-2057" data-mp="1fiu5h49m15do"></div>
              </div>
            </div>

            {/* Alerts Card */}
            <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center gap-4" data-id="element-2058" data-mp="1aes0s1t13ec4">
              <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-2059" data-mp="1fdd264k0o425">
                <ShieldAlertIcon size={24} className="text-red-500" data-id="element-2060" data-mp="1k5weyzavqv5w" />
              </div>
              <div data-id="element-2061" data-mp="1o5oekmiapqz4">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-2062" data-mp="1o66j06f43bi4">
                  Active Alerts
                </p>
                <p className="text-2xl font-bold text-[#111111] leading-none" data-id="element-2063" data-mp="1y4w0vz70cvyd">
                  2
                </p>
              </div>
            </div>
          </div>

          {/* Next Action Card */}
          <Link to="/learn/module-7" className="bg-[#8528e2] rounded-2xl p-6 text-white shadow-md flex flex-col md:flex-row md:items-center justify-between gap-6 no-underline hover:bg-[#7322c4] transition-colors" data-id="element-2064" data-mp="3r4lsk5wtjvj">
            <div data-id="element-2065" data-mp="2alx4it3mssus">
              <p className="text-sm font-bold text-[#d0bdf5] uppercase tracking-wider mb-2" data-id="element-2066" data-mp="2alexr2jcew8m">
                Your Next Action
              </p>
              <h3 className="text-xl font-bold mb-2" data-id="element-2067" data-mp="2kdkok8xuz7m8">
                Recognizing Scams &amp; Phishing
              </h3>
              <div className="flex items-center gap-2 text-sm text-[#e8dcfc]" data-id="element-2068" data-mp="2ffj53mwit6a8">
                <ClockIcon size={16} data-id="element-2069" data-mp="1rnub8241w9r6" />
                <span data-id="element-2070" data-mp="1rovwezes6cmm">Est. time: 5-7 mins</span>
              </div>
            </div>
            <span className="bg-white text-[#8528e2] px-6 py-3 rounded-xl font-bold shrink-0 text-center" data-id="element-2071" data-mp="1mr3udckf9a4p">
              Start Action
            </span>
          </Link>

          {/* Family Members */}
          <div data-id="element-2072" data-mp="1wm5kobqfoi8v">
            <div className="flex items-center justify-between mb-4" data-id="element-2073" data-mp="1wptdf8o210mj">
              <h2 className="text-lg font-bold text-[#111111]" data-id="element-2074" data-mp="3c35xn9qh44ie">
                Family Members
              </h2>
              <button className="text-sm font-bold text-[#8528e2] hover:text-[#7322c4]" data-id="element-2075" data-mp="382cesurw1fwd">
                Invite Member
              </button>
            </div>
            <div className="flex overflow-x-auto pb-4 -mx-6 px-6 md:mx-0 md:px-0 gap-4 hide-scrollbar" data-id="element-2076" data-mp="3km0z78x7ea08">
              {FAMILY_MEMBERS.map(member => <button key={member.id} onClick={() => setSelectedMember(member)} className="bg-white border border-gray-200 rounded-2xl p-5 min-w-[240px] flex-shrink-0 text-left hover:border-[#8528e2] transition-colors shadow-sm" data-id="element-2077" data-mp="35qbklvuckz5j">
                  <div className="flex items-start justify-between mb-4" data-id="element-2078" data-mp="78fotuio32cc">
                    <div className="flex items-center gap-3" data-id="element-2079" data-mp="3omjp2xfjd5zs">
                      <div className={`w-10 h-10 rounded-full ${member.avatarColor} text-white flex items-center justify-center font-bold text-sm`} data-id="element-2080" data-mp="3tle7vzdi6ujw">
                        {member.initials}
                      </div>
                      <div data-id="element-2081" data-mp="pyxhjz3i1xxp">
                        <h3 className="font-bold text-[#111111] leading-tight" data-id="element-2082" data-mp="2gckyvd31i6gd">
                          {member.name}
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-2083" data-mp="2kdwnbfa6glmz">
                          {member.role}
                        </span>
                      </div>
                    </div>
                    <div className="relative w-8 h-8 shrink-0" data-id="element-2084" data-mp="2bcgehbz0grkv">
                      <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100" data-id="element-2085" data-mp="1wovazgy84qcf">
                        <circle cx="50" cy="50" r="45" fill="none" stroke="#f3f4f6" strokeWidth="12" data-id="element-2086" data-mp="1nofbeiklq3cu" />
                        <circle cx="50" cy="50" r="45" fill="none" stroke={member.score > 0 ? '#0EB4CC' : '#e5e7eb'} strokeWidth="12" strokeLinecap="round" strokeDasharray="282.7" strokeDashoffset={282.7 - 282.7 * (member.score / 1000)} data-id="element-2087" data-mp="1dsc7p8a3pwns" />
                      </svg>
                    </div>
                  </div>
                  <div className={`inline-flex px-2.5 py-1 rounded-md text-xs font-bold ${member.statusColor}`} data-id="element-2088" data-mp="1e12wsvxnun6e">
                    {member.status}
                  </div>
                </button>)}
            </div>
          </div>

          {/* Activity Feed */}
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm" data-id="element-2089" data-mp="21pm87kc0bg2p">
            <h2 className="text-lg font-bold text-[#111111] mb-6" data-id="element-2090" data-mp="1wrugorf9xvz1">
              Family Activity
            </h2>
            <div className="space-y-6" data-id="element-2091" data-mp="23vagifdexb1h">
              {ACTIVITY_FEED.map((item, index) => <div key={item.id} className="flex gap-4 relative" data-id="element-2092" data-mp="28su4i6zwx26m" data-mpi={index}>
                  {index !== ACTIVITY_FEED.length - 1 && <div className="absolute left-5 top-10 bottom-[-24px] w-px bg-gray-200" data-id="element-2093" data-mp="2dr40ukxdi8tt"></div>}
                  <div className="w-10 h-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center shrink-0 z-10" data-id="element-2094" data-mp="2ilhyyv3f6u26">
                    {item.icon}
                  </div>
                  <div className="pt-2" data-id="element-2095" data-mp="2ria8j4at3crs">
                    <p className="text-sm font-medium text-[#111111]" data-id="element-2096" data-mp="2wiofsk4l2ior">
                      {item.title}
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-2097" data-mp="31gyc4y21npby">{item.time}</p>
                  </div>
                </div>)}
            </div>
            <button className="w-full mt-6 py-3 text-sm font-bold text-[#8528e2] bg-[#f0ebf8] rounded-xl hover:bg-[#e4d5f5] transition-colors" data-id="element-2098" data-mp="1748j0iji2k5m">
              View All Activity
            </button>
          </div>
        </div>
      </main>

      {/* --- Mobile Bottom Tab Bar --- */}
      <nav className="md:hidden fixed bottom-0 w-full bg-white border-t border-gray-200 flex items-center justify-around pb-safe pt-2 px-2 z-20" data-id="element-2099" data-mp="us62jus1z11b">
        {[{
        name: 'Home',
        icon: HomeIcon
      }, {
        name: 'Family',
        icon: UsersIcon
      }, {
        name: 'Actions',
        icon: BookOpenIcon
      }, {
        name: 'Tasks',
        icon: CheckSquareIcon
      }, {
        name: 'Profile',
        icon: UserIcon
      }].map(item => <button key={item.name} onClick={() => setActiveTab(item.name)} className={`flex flex-col items-center p-2 min-w-[64px] ${activeTab === item.name ? 'text-[#8528e2]' : 'text-gray-400'}`} data-id="element-2100" data-mp="13ooscy4zm8to">
            <item.icon size={24} className="mb-1" data-id="element-2101" data-mp="1h137h0pchnzu" />
            <span className="text-[10px] font-medium" data-id="element-2102" data-mp="1gzial4fk5syt">{item.name}</span>
          </button>)}
      </nav>

      {/* --- Member Detail Drawer --- */}
      <AnimatePresence data-id="element-2103" data-mp="1748aim8pzvno">
        {selectedMember && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setSelectedMember(null)} className="fixed inset-0 bg-black/40 z-40" data-id="element-2104" data-mp="1c3bahs9ufbos" />

            {/* Drawer */}
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed inset-y-0 right-0 w-full md:w-[400px] bg-white shadow-2xl z-50 flex flex-col" data-id="element-2105" data-mp="1uryfybvxm32w">
              {/* Drawer Header */}
              <div className="p-6 border-b border-gray-100 bg-[#f8f8f8]" data-id="element-2106" data-mp="36kqtncs94756">
                <div className="flex items-start justify-between mb-6" data-id="element-2107" data-mp="32k6u62k7grfv">
                  <div className="flex items-center gap-4" data-id="element-2108" data-mp="2euvs8hr4cr05">
                    <div className={`w-14 h-14 rounded-full ${selectedMember.avatarColor} text-white flex items-center justify-center font-bold text-xl`} data-id="element-2109" data-mp="2evdy863l2jl9">
                      {selectedMember.initials}
                    </div>
                    <div data-id="element-2110" data-mp="2ivel8f4r033x">
                      <h2 className="text-xl font-bold text-[#111111]" data-id="element-2111" data-mp="2iuwcwk4t9yfn">
                        {selectedMember.name}
                      </h2>
                      <span className="text-sm text-gray-500" data-id="element-2112" data-mp="1r5jhhdg58avq">
                        {selectedMember.role}
                      </span>
                    </div>
                  </div>
                  <button onClick={() => setSelectedMember(null)} className="p-2 text-gray-400 hover:bg-gray-200 rounded-full transition-colors" data-id="element-2113" data-mp="3v94o3qkddywd">
                    <XIcon size={20} data-id="element-2114" data-mp="8tjtzc3fp91u" />
                  </button>
                </div>

                <div className="flex items-center gap-4 bg-white p-4 rounded-xl border border-gray-200" data-id="element-2115" data-mp="8ve7448grwvd">
                  <div className="relative w-12 h-12 shrink-0" data-id="element-2116" data-mp="3caa9chkwoyg7">
                    <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100" data-id="element-2117" data-mp="3cailg797fzqc">
                      <circle cx="50" cy="50" r="45" fill="none" stroke="#f3f4f6" strokeWidth="10" data-id="element-2118" data-mp="3m8pzah8761o4" />
                      <circle cx="50" cy="50" r="45" fill="none" stroke={selectedMember.score > 0 ? '#0EB4CC' : '#e5e7eb'} strokeWidth="10" strokeLinecap="round" strokeDasharray="282.7" strokeDashoffset={282.7 - 282.7 * (selectedMember.score / 1000)} data-id="element-2119" data-mp="2m09sxtfvxlfx" />
                    </svg>
                  </div>
                  <div data-id="element-2120" data-mp="1tcnchklk6mbn">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-0.5" data-id="element-2121" data-mp="1tbufvcgbdd78">
                      Protection Score
                    </p>
                    <p className="text-lg font-bold text-[#111111] leading-none" data-id="element-2122" data-mp="3npvf3yfs027u">
                      {selectedMember.score}{' '}
                      <span className="text-sm text-gray-400 font-normal" data-id="element-2123" data-mp="3ir21m60hob7o">
                        / 1000
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Drawer Tabs */}
              <div className="flex border-b border-gray-200 px-6" data-id="element-2124" data-mp="2hvwn9a6i59al">
                {['Overview', 'Progress', 'Permissions'].map(tab => <button key={tab} onClick={() => setDrawerTab(tab)} className={`pb-3 pt-4 px-4 text-sm font-bold relative ${drawerTab === tab ? 'text-[#8528e2]' : 'text-gray-500 hover:text-gray-800'}`} data-id="element-2125" data-mp="2msvar9vnuhzt">
                    {tab}
                    {drawerTab === tab && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#8528e2]" data-id="element-2126" data-mp="23v2ayggc2o6n" />}
                  </button>)}
              </div>

              {/* Drawer Content */}
              <div className="flex-1 overflow-y-auto p-6" data-id="element-2127" data-mp="1mnb52i6kz4jr">
                {drawerTab === 'Overview' && <div className="space-y-6" data-id="element-2128" data-mp="1hohq0lbnb5hh">
                    <div data-id="element-2129" data-mp="1hlc39cqhofox">
                      <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4" data-id="element-2130" data-mp="1wckzi4owczb1">
                        Top Tasks
                      </h3>
                      <div className="space-y-3" data-id="element-2131" data-mp="1rj9qpy0iy8gh">
                        {['Update iPhone to iOS 17.4', 'Enable MFA on primary email', 'Complete Scam Recognition module'].map((task, i) => <div key={i} className="flex items-start gap-3 p-3 rounded-xl border border-gray-100 bg-gray-50" data-id="element-2132" data-mp="2f8ugazr6o3yq" data-mpi={i}>
                            <div className="w-5 h-5 rounded border border-gray-300 mt-0.5 bg-white shrink-0" data-id="element-2133" data-mp="kyqt6ffvt68i"></div>
                            <span className="text-sm text-[#111111]" data-id="element-2134" data-mp="27meg2u988ty2">
                              {task}
                            </span>
                          </div>)}
                      </div>
                    </div>

                    <div className="space-y-3 pt-4" data-id="element-2135" data-mp="2hby0438oetui">
                      <button className="w-full py-3.5 bg-[#8528e2] text-white rounded-xl font-bold hover:bg-[#7322c4] transition-colors shadow-sm" data-id="element-2136" data-mp="2ccuscb1ba9iu">
                        Send a Nudge
                      </button>
                      <button className="w-full py-3.5 bg-white border border-gray-200 text-[#111111] rounded-xl font-bold hover:bg-gray-50 transition-colors shadow-sm" data-id="element-2137" data-mp="1kn8ga7dhnr5w">
                        Assist This Member
                      </button>
                    </div>
                  </div>}

                {drawerTab === 'Progress' && <div className="space-y-6" data-id="element-2138" data-mp="3520ni61nbbms">
                    {[{
                level: 'Essential Protection',
                progress: 80
              }, {
                level: 'Advanced Protection',
                progress: 30
              }, {
                level: 'Full Coverage',
                progress: 0
              }].map((lvl, i) => <div key={i} data-id="element-2139" data-mp="1ai04u36ewcbt" data-mpi={i}>
                        <div className="flex justify-between text-sm mb-2" data-id="element-2140" data-mp="1airyh8gg7zzg">
                          <span className="font-bold text-[#111111]" data-id="element-2141" data-mp="1eisfn0uxmpa7">
                            {lvl.level}
                          </span>
                          <span className="text-gray-500" data-id="element-2142" data-mp="10qmb6c1566ql">{lvl.progress}%</span>
                        </div>
                        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-2143" data-mp="1th4bx6ee7w0u">
                          <div className="h-full bg-[#0EB4CC] rounded-full" style={{
                    width: `${lvl.progress}%`
                  }} data-id="element-2144" data-mp="1tf9onlfnfrtl"></div>
                        </div>
                      </div>)}
                  </div>}

                {drawerTab === 'Permissions' && <div className="space-y-6" data-id="element-2145" data-mp="1t7bywdopyoj3">
                    <div className="bg-blue-50 p-4 rounded-xl border border-blue-100 flex gap-3" data-id="element-2146" data-mp="1t6ajxy4l1hw3">
                      <ShieldCheckIcon className="text-blue-500 shrink-0" size={20} data-id="element-2147" data-mp="1p6a0fz2mmgi6" />
                      <p className="text-xs text-blue-800 leading-relaxed" data-id="element-2148" data-mp="1fecmikk8hafr">
                        These settings are controlled by the member. You can
                        request changes, but they must approve them.
                      </p>
                    </div>

                    <div className="space-y-4" data-id="element-2149" data-mp="11fmngzdut0or">
                      {[{
                  name: 'View Progress Score',
                  enabled: true
                }, {
                  name: 'Receive Security Alerts',
                  enabled: true
                }, {
                  name: 'Remote Assist Access',
                  enabled: false
                }].map((perm, i) => <div key={i} className="flex items-center justify-between py-2" data-id="element-2150" data-mp="2tcnv7ngvxesp" data-mpi={i}>
                          <span className="text-sm font-medium text-[#111111]" data-id="element-2151" data-mp="33c4xrw0ubckg">
                            {perm.name}
                          </span>
                          <div className={`w-11 h-6 rounded-full flex items-center px-1 transition-colors ${perm.enabled ? 'bg-[#0EB4CC]' : 'bg-gray-200'}`} data-id="element-2152" data-mp="2ao930wutzuqb">
                            <div className={`w-4 h-4 rounded-full bg-white shadow-sm transform transition-transform ${perm.enabled ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2153" data-mp="l6m04sdrhdq9"></div>
                          </div>
                        </div>)}
                    </div>
                  </div>}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}